import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

// attach token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jp_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;

// Convert relative photo url -> absolute
export const photoUrl = (relative) => {
  if (!relative) return "";
  if (relative.startsWith("http")) return relative;
  return `${BACKEND}${relative}`;
};
